import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useAcknowlegeFile } from 'file_folder_repository/queries/acknowledge'
import {
  useFileDetails,
  useFolderDetails,
} from 'file_folder_repository/queries/details'
import { useSignFile } from 'file_folder_repository/queries/sign'
import { AcknowledgeResourceScreenProps } from 'home/stack/types'
import { useCallback, useLayoutEffect } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { AcknowledgeResourceView } from './views'

export function AcknowledgeResourceScreen({
  navigation,
  route,
}: AcknowledgeResourceScreenProps) {
  const { handleNavigation } = useRoutingContext()
  const { resourceId, resourceType } = route.params
  const acknowledgeFileMutation = useAcknowlegeFile()
  const signFileMutation = useSignFile()
  const fileDetailsQuery = useFileDetails(resourceId, resourceType === 'file')
  const folderDetailsQuery = useFolderDetails(
    resourceId,
    resourceType === 'folder'
  )
  const resourceDetailsQuery =
    resourceType === 'file' ? fileDetailsQuery : folderDetailsQuery

  const acknowledgement =
    resourceDetailsQuery.data?.type === 'file' &&
    resourceDetailsQuery.data?.resourceAcknowledgements?.[0]
  const title = acknowledgement
    ? acknowledgement.requireSign
      ? t('openAndSign')
      : t('openAndAck')
    : undefined

  const onPressThumbnail = useCallback(() => {
    if (resourceDetailsQuery.data?.type === 'file') {
      handleNavigation({
        routeName: 'file_viewer',
        routeParams: { fileId: resourceDetailsQuery.data.id },
      })
    }
  }, [resourceDetailsQuery.data, handleNavigation])

  const onSubmit = useCallback(async () => {
    if (resourceDetailsQuery.data?.type === 'file' && acknowledgement) {
      try {
        if (acknowledgement.requireSign) {
          await signFileMutation.mutateAsync({
            fileId: resourceDetailsQuery.data.id,
          })
        }
        await acknowledgeFileMutation.mutateAsync({
          fileId: resourceDetailsQuery.data.id,
        })
        navigation.goBack()
      } catch (error) {
        errorAlert(error)
      }
    }
  }, [
    resourceDetailsQuery,
    acknowledgement,
    acknowledgeFileMutation,
    navigation,
    signFileMutation,
  ])

  useLayoutEffect(() => {
    if (title) {
      showHeaderTitle(navigation, title)
    }
  }, [navigation, title])

  return (
    <StatusBoundary
      isLoading={resourceDetailsQuery.isLoading}
      error={resourceDetailsQuery.error}
    >
      <AcknowledgeResourceView
        resource={resourceDetailsQuery.data}
        onPressThumbnail={onPressThumbnail}
        onSubmit={onSubmit}
      />
    </StatusBoundary>
  )
}
